import type { FaireProductEntity } from "../../entity_types/product";

export const p_eunmj5rq9y: FaireProductEntity = {
  token: "p_eunmj5rq9y",
  type: "product",
  name: "Balm Baby - SHEW BUG! {Natural Bug Repellant Spray}",
  brandToken: "b_b3ffvix4",
  brandName: "Taylor's Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/63ef419d06e7bfb04072bea2bffba078f7bacdf4792d3ffb8b3a8e6441482e3f.png",
  galleryImageUrls: [],
  priceDollars: 5.75,
  description:
    'All Natural Bug Repellant Spray that will REPELL those bugs away!  * Deet Free*\n\nA unique formula of ALL NATURAL and ORGANIC ingredients that are free of chemicals!\n\nFormulated in Hawaii, with a TROPICAL climate ALL YEAR ROUND, bugs are everywhere and this formula has been put to the test!  It is A MUST HAVE!  Works like no other and doesn\'t smell like chemicals (like other bug sprays)!\n\n\nI said SHEW BUG don\'t bother me!\n\n•\tEasy Spray Keeps biting bugs away!\n•\tConvenient 2.7oz. in recycled aluminum bottle with sprayer  \n•\tPerfect travel size \n•\tOrganic and Natural, Hand Crafted in the USA\n•\tPerfect for "buggy" areas\n•\tNice, natural smell, not like "normal" smelling bug repellents\n•\tVegan / Nut FREE / Gluten Free / Deet Free\n•\tCruelty Free (Leaping Bunny Certified)\n•\tSee separate listing for REFILL sizes in glass bottle\n\nIngredients:  Witch hazel, organic extra virgin olive oil, organic neem oil, essential oil blend of organic orange, peppermint, eucalyptus, cedarwood & Vit E\n',
  tags: [],
  msrpDollars: 11.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:47.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
